import AzImg from '~/components/Atoms/AzImg.vue';
export default defineComponent({
  name: 'BlockImagesTextImageLeftTextRight',
  components: {
    AzImg: AzImg
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    classes: {
      type: Object,
      default: function _default() {}
    },
    pictos: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    leafListOption: Boolean,
    isPageAdvice: Boolean
  },
  setup: function setup() {
    var getTwicPicImg = function getTwicPicImg(image) {
      var _image$fields, _image$fields$file;
      return (image === null || image === void 0 ? void 0 : (_image$fields = image.fields) === null || _image$fields === void 0 ? void 0 : (_image$fields$file = _image$fields.file) === null || _image$fields$file === void 0 ? void 0 : _image$fields$file.url) || '';
    };

    /**
     * Gets the picture title.
     *
     * @param      {object}  picture  The picture
     * @return     {string}  The picture title.
     */
    function getPictureTitle(picture) {
      var _picture$fields$title, _picture$fields;
      return (_picture$fields$title = picture === null || picture === void 0 ? void 0 : (_picture$fields = picture.fields) === null || _picture$fields === void 0 ? void 0 : _picture$fields.title) !== null && _picture$fields$title !== void 0 ? _picture$fields$title : '';
    }
    return {
      getTwicPicImg: getTwicPicImg,
      getPictureTitle: getPictureTitle
    };
  }
});